// FlixMessageId.jsx
import React from 'react';

import MongoObjectIdMatcher from '../component/MongoObjectIdMatcher.jsx';
import Redirect from '../container/Redirect.js';
import { reactRouterNoindexLoader } from '../resource/reactRouterNoindexLoader.js';

export const loader = reactRouterNoindexLoader;

const FlixMessageIdRoute = () => {
  return (
    <MongoObjectIdMatcher paramKeys={['messageId']}>
      <Redirect to="/post/:messageId" status={301} />
    </MongoObjectIdMatcher>
  );
};

export default FlixMessageIdRoute;
